export const CANONICAL_MINT = 'DkSvXp2TPiGZ1NVj1gGXfCqb4djZqUTV8X1PZUVyMtZP';

export const DEFAULT_SCORE_WEIGHTS = {
  velocity: 18,
  reach: 10,
  freshness: 15,
  memeability: 15,
  visualPotential: 8,
  mintyFit: 20,
  cryptoCrossover: 7,
  competition: 3,
  shelfLife: 4,
} as const;

export const SCORE_BANDS = [
  { min: 85, label: 'BREAKING CASE', tone: 'critical' },
  { min: 75, label: 'HOT CASE', tone: 'hot' },
  { min: 68, label: 'GOOD CASE', tone: 'rising' },
  { min: 60, label: 'WATCH', tone: 'watch' },
  { min: 0, label: 'LOW PRIORITY', tone: 'quiet' },
] as const;

export const MINTY_FIT_GATE = 65;
export const CREATIVE_REVIEW_THRESHOLD = 68;
export const HOT_CASE_THRESHOLD = 75;
export const BREAKING_CASE_THRESHOLD = 85;
export const HERO_THRESHOLD = CREATIVE_REVIEW_THRESHOLD;

export const CASE_STATUSES = ['OPEN', 'RESEARCHING', 'READY', 'APPROVED', 'SCHEDULED', 'LIVE', 'CLOSED', 'ARCHIVED'] as const;
export const CONTENT_STATUSES = ['DRAFT', 'AI CHECKED', 'HUMAN REVIEW', 'APPROVED', 'SCHEDULED', 'PUBLISHED', 'FAILED'] as const;

export type ScoreComponents = {
  velocity: number;
  reach: number;
  freshness: number;
  memeability: number;
  visualPotential: number;
  mintyFit: number;
  cryptoCrossover: number;
  competition: number;
  shelfLife: number;
  risk: number;
};

export function calculateViralScore(components: ScoreComponents, weights = DEFAULT_SCORE_WEIGHTS) {
  const positiveKeys: Array<Exclude<keyof ScoreComponents,'risk'>> = ['velocity', 'reach', 'freshness', 'memeability', 'visualPotential', 'mintyFit', 'cryptoCrossover', 'competition', 'shelfLife'];
  const positive = positiveKeys.reduce((sum, key) => sum + components[key] * weights[key], 0);
  const totalWeight = Object.values(weights).reduce((sum, weight) => sum + weight, 0);
  const base = positive / totalWeight;
  const riskPenalty = Math.round(Math.max(0, components.risk - 35) * 0.28);
  const gated = components.mintyFit < MINTY_FIT_GATE ? Math.min(HOT_CASE_THRESHOLD - 1, base) : base;
  return Math.max(0, Math.min(100, Math.round(gated - riskPenalty)));
}

export function scoreBand(score: number) {
  return SCORE_BANDS.find((band) => score >= band.min) ?? SCORE_BANDS[4];
}

export function qualifiesForCreativeReview(score:number,mintyFit:number){
  return score>=CREATIVE_REVIEW_THRESHOLD&&mintyFit>=MINTY_FIT_GATE;
}

export function qualifiesForHero(score:number,mintyFit:number,recommendation:string){
  return qualifiesForCreativeReview(score,mintyFit)&&['CREATE NOW','CREATE'].includes(recommendation);
}
